import { createNullableProvideInject } from '@collector/shared-ui'

import { VIPIncidentsConfig } from '../configuration'

export const [provideVIPIncidentsConfig, injectVIPIncidentsConfig] =
  createNullableProvideInject<VIPIncidentsConfig>('vipIncidentsConfig')
